import { Themes } from '@figure/frontlib-gui';

// Because autocomplete from gui fails
export const FIGURE = Themes.FIGURE;

const ThemeHelper = () => {
  const hostname = window.location.hostname;
  if ([...Themes.MERCHANT_PROVIDERS, ...Themes.WHITE_LABEL_ORGS].some((org) => hostname.indexOf(org) > -1)) {
    return [...Themes.MERCHANT_PROVIDERS, ...Themes.WHITE_LABEL_ORGS].find((org) => hostname.indexOf(org) > -1);
  } else if (hostname.indexOf('localhost') > -1 && process.env.REACT_APP_CUSTOMER_TYPE) {
    return process.env.REACT_APP_CUSTOMER_TYPE;
  } else {
    // always fallback to figure
    return Themes.FIGURE;
  }
};

const NO_STYLE_CHANGE_ORGS = [];

export const mode = ThemeHelper();
export const stylingMode = NO_STYLE_CHANGE_ORGS.includes(mode) ? Themes.FIGURE : mode;

export const isFigure = mode === FIGURE;
export const isMerchant = Themes.MERCHANT_PROVIDERS.includes(mode);
export const isWhiteLabel = Themes.WHITE_LABEL_ORGS.includes(mode);

export default ThemeHelper;

export const selectByTheme = (content, defaultFigure = true) => {
  if (typeof content[mode] !== 'undefined') return content[mode];
  else return defaultFigure ? content[FIGURE] : null;
};
